import { Draft, produce } from 'immer';

import * as TYPES from '@app/store/actionTypes';
import {
  scheduledDocumentPreviewDataFetched,
  setupTemplateByDraft,
  TemplateAction,
} from '@app/store/template/actions';

export interface TemplateFieldSizesState {
  [id: string]: {
    currentScaleHeight: number;
    currentScaleWidth: number;
    relativeWidth: number;
    relativeHeight: number;
  };
}

const initialState: TemplateFieldSizesState = {};

const reducer = produce((draft: Draft<TemplateFieldSizesState>, action: TemplateAction) => {
  switch (action.type) {
    case TYPES.TEMPLATE_CLEAR_ALL_STATE:
    case TYPES.TEMPLATE_INFORMATION_FETCH_REQUEST:
      return initialState;
    case scheduledDocumentPreviewDataFetched.type:
    case TYPES.TEMPLATE_INFORMATION_FETCH_SUCCESS: {
      const { participants } = action.payload;
      participants.forEach((participant) => {
        const { fields } = participant;
        const { signatureFields, textFields, checkboxGroups } = fields;

        signatureFields.forEach((signatureField) => {
          draft[signatureField.id] = {
            currentScaleHeight: 0,
            currentScaleWidth: 0,
            relativeHeight: 0,
            relativeWidth: 0,
          };
        });
        textFields.forEach((textField) => {
          draft[textField.id] = {
            currentScaleHeight: 0,
            currentScaleWidth: 0,
            relativeHeight: textField.height,
            relativeWidth: textField.width,
          };
        });
        checkboxGroups.forEach((checkboxGroup) => {
          draft[checkboxGroup.id] = {
            currentScaleHeight: 0,
            currentScaleWidth: 0,
            relativeHeight: checkboxGroup.height,
            relativeWidth: checkboxGroup.width,
          };
        });
      });
      return draft;
    }
    case setupTemplateByDraft.type: {
      action.payload.participants.forEach((participant) => {
        participant.fields.forEach((field) => {
          draft[field.id] = {
            currentScaleHeight: 0,
            currentScaleWidth: 0,
            relativeHeight: field.size?.height ?? 0,
            relativeWidth: field.size?.width ?? 0,
          };
        });
      });

      return draft;
    }
    case TYPES.TEMPLATE_FIELD_CREATE: {
      const { currentScaleHeight, currentScaleWidth, id } = action.payload.meta;
      draft[id] = {
        currentScaleHeight,
        currentScaleWidth,
        relativeWidth: 0,
        relativeHeight: 0,
      };
      return draft;
    }
    case TYPES.TEMPLATE_FIELD_SIZE_CHANGE: {
      const { currentScaleHeight, currentScaleWidth, id, relativeHeight, relativeWidth } =
        action.payload;
      draft[id] = {
        currentScaleHeight,
        currentScaleWidth,
        relativeWidth,
        relativeHeight,
      };
      return draft;
    }
    case TYPES.TEMPLATE__FIELDS_OVER_MAX_DOCUMENT_PAGE_DELETE: {
      const { fieldIds } = action.payload;
      fieldIds.forEach((key) => {
        if (key in draft) {
          delete draft[key];
        }
      });
      return draft;
    }
    default:
      return draft;
  }
}, initialState);

export default reducer;
